/**
 * Extract plain text from an HTML string (e.g. RichTextEditor/Quill output),
 * for length checks and previews (push notifications, char counters) where
 * raw HTML tags shouldn't count or show up.
 */
export function getPlainText(html) {
  if (!html) return '';
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return (temp.innerText || temp.textContent || '').trim();
}
